import React, { useState, useRef, useEffect } from "react";
import {
    Container,
    Row,
    Col,
    Table,
    Button,
} from "reactstrap";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Logo from "../../assets/images/logo-portrait@2x.png";
import { useReactToPrint } from "react-to-print";
import { CreateEventLogTextFileForInbox } from "../../components/common/EventLog/EventLog";
import { useDispatch } from "react-redux";
import { storeCurrentRoute } from "../../utils/routeTracker";
import translateFile from "../../config/TranslateFile.jsx";
import { getStoredValue, setStoredValue } from "../../_helpers/storagehelper.js";

const PaymentReceipt = () => {
    const componentRef = useRef();
    const navigate = useNavigate();
    const [isPrintData, setIsPrintData] = useState(false);
    const [ColumnOrderData, setColumnOrderData] = useState(Date);
    const [PaymentDetails, setPaymentDetails] = useState(null);
    const location = useLocation();
    const dispatch = useDispatch();
    const currentLang = translateFile();
    // const { PaymentDetails } = location.state || "";

    const date = new Date();
    const formattedDateTime = date.toLocaleString();

    // Handle the print trigger logic
    const handlePrintShow = () => {
        // Update print data if needed
        setIsPrintData(true);

        // Trigger the printing after a brief delay
        setTimeout(() => {
            handlePrints(); // Trigger the print
        }, 10);

        // Reset after the print action is triggered
        setTimeout(() => {
            setIsPrintData(false); // Hide the form again after print
        }, 500);
    };

    useEffect(() => {
        window.history.pushState(null, document.title);
        const handleBeforeUnload = (event) => {
            event.preventDefault();
            event.returnValue = '';
            navigate(0);
        };

        window.addEventListener('popstate', handleBeforeUnload);

        return () => {
            window.removeEventListener('popstate', handleBeforeUnload);
        };
    }, [navigate]);

    const handlePrints = useReactToPrint({
        pageStyle: `
      @media print {
        @page {
          margin: 5mm; /* Keep margins flexible */
        }
        body {
          margin: 0;
          padding: 0;
        }
        .print-content {
          margin-top: 5mm;
        }
      }
    `,
        content: () => componentRef.current, // Content to print
        onBeforeGetContent: () => {

        },
        onAfterPrint: () => {

            // Optionally reset the print state after the printing is done
            setIsPrintData(false);
        },
    });

    const handleClick = () => {
        const infoMessage = "Payment completed";
        const redirectURL = "Page Redirect from PurchaseCredits to Mycontacts";
        const Status = "---";
        const Response = "Payment " + PaymentDetails?.PaymentStatus || "";
        CreateEventLogTextFileForInbox(dispatch, infoMessage, redirectURL, Response, Status);
        navigate("/public/Mycontacts");
        storeCurrentRoute("/public/Mycontacts");
    };

    useEffect(() => {
        if (location.state?.PaymentDetails) {
            setStoredValue(
                "PaymentDetails",
                location.state.PaymentDetails
            );
            setPaymentDetails(location.state.PaymentDetails);
        } else {
            const savedDetails = getStoredValue("PaymentDetails");
            if (savedDetails) {
                setPaymentDetails(typeof savedDetails === "string" ? JSON.parse(savedDetails) : savedDetails);
            }
        }
    }, [location.state]);


    return (
        <div className="card mt-5 p-4 border-radius-all shadow-sm mb-4">
            <div className="text-center">
                <Row>
                    <Col md="4" sm="4"></Col>
                    <Col md="4" sm="4">
                        <div className="invoice-logo">
                            <div className="logo">
                                <img
                                    className="mx-auto"
                                    src={Logo}
                                    alt="Logo"
                                    width={150}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col md="4" sm="4"></Col>
                </Row>
                <h2 className="text-danger mt-3">{currentLang?.PurchaseCreditsPage?.EReceipt}</h2>
                <p className="text-muted">
                    {currentLang?.PurchaseCreditsPage?.Order_ID} <strong>{PaymentDetails?.POTransactionRandomID}</strong>
                </p>
                <hr />
            </div>

            <div className="row mb-4">
                <div className="col-md-3">
                    <p className="text-danger"><strong>{currentLang?.PurchaseCreditsPage?.RECEIPT_TO}</strong></p>
                    <p className="mb-1">{PaymentDetails?.UserName}</p>
                    <p>{PaymentDetails?.Email}</p>
                </div>
                <div className="col-md-3">
                    <p className="text-danger"><strong>{currentLang?.PurchaseCreditsPage?.TRANSACTION_DATE}</strong></p>
                    <p>{PaymentDetails?.TransactionDate}</p>
                </div>
                <div className="col-md-3">
                    <p className="text-danger"><strong>{currentLang?.PurchaseCreditsPage?.PAYMENT_STATUS}</strong></p>
                    <p className="text-success-default fw-600 first-letter-capitalize"><i class="fa-regular fa-circle-check me-2"></i>{PaymentDetails?.PaymentStatus}</p>
                </div>
                <div className="col-md-3">
                    <p className="text-danger"><strong>{currentLang?.PurchaseCreditsPage?.PAYMENT_METHOD}</strong></p>
                    <p>{PaymentDetails?.PaymentType}</p>
                </div>
            </div>

            <h3 className="text-danger border-bottom pb-2">{currentLang?.PurchaseCreditsPage?.ORDER_SUMMARY}</h3>

            <table className="table table-striped table-bordered mt-3">
                <thead className="bg-light text-danger">
                    <tr>
                        <th>{currentLang?.PurchaseCreditsPage?.SNO}</th>
                        <th>{currentLang?.PurchaseCreditsPage?.DESCRIPTION}</th>
                        <th className="text-end">{currentLang?.PurchaseCreditsPage?.AMOUNT}</th>
                    </tr>
                </thead>
                <tbody>

                    <tr >
                        <td>1</td>
                        <td>
                            <h5>{currentLang?.PurchaseCreditsPage?.Inmate_Deposit}</h5>
                            {currentLang?.PurchaseCreditsPage?.Transaction_ID} {PaymentDetails?.PaymentTransactionID}
                            <br />
                            {currentLang?.PurchaseCreditsPage?.For_Inmate} {PaymentDetails?.InmateFullName}
                            <br />
                            {currentLang?.PurchaseCreditsPage?.Facility} {PaymentDetails?.FacilityName}
                        </td>
                        <td className="text-end">${parseFloat(PaymentDetails?.PurchaseAmount).toFixed(2)}</td>
                    </tr>

                    <tr>
                        <td></td>
                        <td className="text-end text-danger"><strong>{currentLang?.PurchaseCreditsPage?.Processing_Fee}</strong></td>
                        <td className="text-end">${parseFloat(PaymentDetails?.ProcessingFee).toFixed(2)}</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td className="text-end text-danger"><strong>{currentLang?.PurchaseCreditsPage?.Total}</strong></td>
                        <td className="text-end"><strong>${parseFloat(PaymentDetails?.TotalAmount).toFixed(2)}</strong></td>
                    </tr>
                </tbody>
            </table>

            <footer className="text-center mt-4 text-muted">
                <p className="font-size-18 fw-700">{currentLang?.PurchaseCreditsPage?.Thank_You}</p>
            </footer>
            <div className="invoice-btn-section clearfix d-print-none">
                <Button
                    className="btn btn-success me-2 font-size-14"
                    style={{ background: "#00BFFF" }}
                    onClick={handlePrintShow} // Trigger print
                >
                    <i className="fa fa-print"></i> {currentLang?.buttons?.Print_Invoice}
                </Button>

                <Button
                    id="invoice_download_btn"
                    onClick={handleClick}
                    className="btn btn-danger"
                >
                    <i class="fa-regular fa-circle-check me-1"></i>
                    {currentLang?.buttons?.Done}
                </Button>
            </div>

            {/* Hidden form to be printed */}
            <form
                ref={componentRef}
                style={isPrintData ? { display: "block" } : { display: "none" }} // Show only when printing
            >
                <div className="p-5">
                    <div style={{ textAlign: "right", fontSize: "16px" }}>
                        <p>{formattedDateTime}</p>
                    </div>
                    <div style={{ textAlign: "center", marginBottom: "20px" }}>
                        <img src={Logo} alt="Logo" style={{ height: "50px" }} />

                    </div>
                    <div className="left-div">
                        <h2>{currentLang?.PurchaseCreditsPage?.EReceipt}</h2>
                        <h4 className="mb-3 pb-2 border-bottom-1">{currentLang?.labels?.Order_ID} <strong>{PaymentDetails?.POTransactionRandomID}</strong></h4>
                    </div>
                    <div style={{ marginBottom: "20px" }}>
                        <table className="font-size-15" style={{ width: "100%", borderCollapse: "collapse" }}>
                            <tbody>
                                <tr>
                                    <td>
                                        <strong>{currentLang?.PurchaseCreditsPage?.RECEIPT_TO} {" : '"}</strong> <p className="font-size-15">
                                            {PaymentDetails?.UserName}<br />
                                            {PaymentDetails?.Email} </p>
                                    </td>
                                    <td className="text-right">
                                        <strong>{currentLang?.PurchaseCreditsPage?.TRANSACTION_DATE} {" : "}</strong> <p className="font-size-15">{PaymentDetails?.TransactionDate}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <strong>{currentLang?.PurchaseCreditsPage?.PAYMENT_STATUS}{" : "}</strong> <p className="font-size-15">{PaymentDetails?.PaymentStatus}</p>
                                    </td>
                                    <td className="text-right">
                                        <strong>{currentLang?.PurchaseCreditsPage?.PAYMENT_METHOD} {" : "}</strong> <p className="font-size-15">{PaymentDetails?.PaymentType}</p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <h3 className="mb-1 pb-3">{currentLang?.PurchaseCreditsPage?.ORDER_SUMMARY}</h3>
                        <table className="font-size-15" style={{ width: "100%" }}>
                            <thead>
                                <tr className="font-size-15">
                                    <th style={{ padding: "8px" }}>{currentLang?.PurchaseCreditsPage?.SNO}</th>
                                    <th style={{ padding: "8px" }}>{currentLang?.PurchaseCreditsPage?.DESCRIPTION}</th>
                                    <th className="text-right" style={{ padding: "8px" }}>{currentLang?.PurchaseCreditsPage?.AMOUNT}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: "8px" }}>1</td>
                                    <td style={{ padding: "8px" }}>
                                        {currentLang?.PurchaseCreditsPage?.Inmate_Deposit}<br />
                                        {currentLang?.PurchaseCreditsPage?.Transaction_ID} {PaymentDetails?.PaymentTransactionID}<br />
                                        {currentLang?.PurchaseCreditsPage?.For_Inmate} {PaymentDetails?.InmateFullName}<br />
                                        {currentLang?.PurchaseCreditsPage?.Facility}{PaymentDetails?.FacilityName}
                                    </td>
                                    <td className="text-right" style={{ padding: "8px" }}>${parseFloat(PaymentDetails?.PurchaseAmount).toFixed(2)}</td>
                                </tr>
                                <tr className="text-right">
                                    <td className="text-right" colSpan="2" style={{ padding: "8px" }}>
                                        <p className="fw-600 text-right mb-0">{currentLang?.PurchaseCreditsPage?.Processing_Fee}</p>
                                    </td>
                                    <td className="text-right" style={{ padding: "8px" }}>${parseFloat(PaymentDetails?.ProcessingFee).toFixed(2)}</td>
                                </tr>
                                <tr className="text-right">
                                    <td className="text-right" colSpan="2" style={{ border: "1px solid black", padding: "8px" }}>
                                        <strong>{currentLang?.PurchaseCreditsPage?.Total}</strong>
                                    </td>
                                    <td className="text-right" style={{ border: "1px solid black", padding: "8px" }}><strong>${parseFloat(PaymentDetails?.TotalAmount).toFixed(2)}</strong></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default React.memo(PaymentReceipt);
